export const actionButtonSx = {
  whiteSpace: 'nowrap',
  flexShrink: 0,
  textTransform: 'none',
  px: 1,
  minWidth: 'auto',
} as const;

export const actionButtonColumnSx = {
  ...actionButtonSx,
  width: '100%',
  maxWidth: 104,
  justifyContent: 'center',
} as const;

export const actionColumnStackSx = {
  spacing: 0.5,
  alignItems: 'center',
  width: '100%',
} as const;

export const actionReorderRowSx = {
  direction: 'row' as const,
  spacing: 0.25,
  justifyContent: 'center',
};

export const reorderButtonSx = {
  flexShrink: 0,
  minWidth: 28,
  px: 0.5,
} as const;

const wrapTextCellSx = {
  whiteSpace: 'normal',
  overflowWrap: 'break-word',
  wordBreak: 'normal',
  verticalAlign: 'top',
} as const;

const topCellSx = { verticalAlign: 'top' } as const;

const compactCellSx = {
  width: '1%',
  whiteSpace: 'nowrap',
  ...topCellSx,
} as const;

const actionsCellSx = {
  width: 108,
  minWidth: 108,
  maxWidth: 108,
  px: 0.5,
  textAlign: 'center',
  ...topCellSx,
} as const;

export const courseTableCellSx = {
  index: { ...compactCellSx, minWidth: 28, px: 0.5, textAlign: 'center' },
  name: { width: '12%', minWidth: 100, ...wrapTextCellSx },
  description: { width: '16%', minWidth: 120, ...wrapTextCellSx },
  count: { ...compactCellSx, minWidth: 48, px: 1, textAlign: 'right' },
  audience: { width: '8%', minWidth: 72, ...wrapTextCellSx },
  status: { width: '9%', minWidth: 96, ...topCellSx },
  access: { width: '10%', minWidth: 124, whiteSpace: 'nowrap', ...topCellSx },
  date: { width: '9%', minWidth: 104, whiteSpace: 'nowrap', ...topCellSx },
  id: { ...compactCellSx, minWidth: 40, px: 0.5 },
  actions: actionsCellSx,
} as const;

export const folderTableCellSx = {
  index: { ...compactCellSx, minWidth: 28, px: 0.5, textAlign: 'center' },
  name: { width: '24%', minWidth: 140, ...wrapTextCellSx },
  status: { width: '12%', minWidth: 96, ...topCellSx },
  lock: { width: '10%', minWidth: 96, ...topCellSx },
  count: { ...compactCellSx, minWidth: 52, px: 1, textAlign: 'right' },
  date: { width: '10%', minWidth: 96, whiteSpace: 'nowrap', ...topCellSx },
  id: { ...compactCellSx, minWidth: 40, px: 0.5 },
  actions: actionsCellSx,
} as const;

export const videoTableCellSx = {
  index: { ...compactCellSx, minWidth: 28, px: 0.5, textAlign: 'center' },
  name: { width: '12%', minWidth: 100, ...wrapTextCellSx },
  description: { width: '16%', minWidth: 120, ...wrapTextCellSx },
  status: { width: '9%', minWidth: 96, ...topCellSx },
  link: {
    width: '18%',
    minWidth: 140,
    ...wrapTextCellSx,
    wordBreak: 'break-all',
  },
  date: { width: '9%', minWidth: 104, whiteSpace: 'nowrap', ...topCellSx },
  id: { ...compactCellSx, minWidth: 40, px: 0.5 },
  actions: actionsCellSx,
} as const;

export const contentTableContainerSx = {
  width: '100%',
  overflowX: 'auto',
} as const;

export const contentCardSx = {
  width: '100%',
} as const;

export const contentTableSx = {
  width: '100%',
  tableLayout: 'auto',
} as const;
